import React from 'react'

const SuccessfulProjects = () => {
    return (
        <>
            <section className="counter pt_80  pb_75" style={{ background: 'url(assets/images/counter_bg.jpg)' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 col-lg-3 col-xl-3 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_counter">
                                <div className="icon">
                                    <img src="assets/images/counter_icon_1.svg" alt="counter" className="iomg-fluid" />
                                </div>
                                <h4><span className="count">200</span>+</h4>
                                <p>successful projects</p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3 col-xl-3 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_counter">
                                <div className="icon">
                                    <img src="assets/images/counter_icon_2.svg" alt="counter" className="iomg-fluid" />
                                </div>
                                <h4><span className="count">1500+</span></h4>
                                <p>Satisfied Clients</p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3 col-xl-3 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_counter">
                                <div className="icon">
                                    <img src="assets/images/counter_icon_3.svg" alt="counter" className="iomg-fluid" />
                                </div>
                                <h4><span className="count">20</span>+</h4>
                                <p>Experienced Staff</p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3 col-xl-3 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_counter">
                                <div className="icon">
                                    <img src="assets/images/counter_icon_4.svg" alt="counter" className="iomg-fluid" />
                                </div>
                                <h4><span className="count">5</span>+</h4>
                                <p>Award Wining</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SuccessfulProjects